import { IStaticRateDateOccupancyRateParsed } from '../entities/IStaticRateDateOccupancyRateParsed';
import { IFilterContent } from '../lists/listTypes';

export interface IContractListState {
    Id: string;
    Enabled: boolean;
    Name: string;
    Description: string;
    IdStaticRateContractStatusType: number;
    StaticRateContractStatusType: string;
    StaticRateContractStatusColor: string;
    IdAgency: number;
    Agency: string;
    IdSupplierHotel: number;
    SupplierHotel: string;
    IdSupplierHotelRatePlan: number;
    SupplierHotelRatePlan: string;
    IdRateScopeModel: number;
    RateScopeModel: string;
    RateScopeModelKey: string;
    ActiveFrom: Date | null;
    ActiveTo: Date | null;
}

export interface IContractSeasonState {
    id: string;
    enabled: boolean;
    name: string;
    start: null | Date;
    end: null | Date;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

// used only for painting the seasons
export interface IContractTimelineSegment {
    id: string | null;
    name: string;
    start: Date;
    end: Date;
    color: string;
    enabled?: boolean;
}

export interface IContractRoomState {
    id: string;
    name: string;
    enabled: boolean;
    idSupplierHotelRoomType: number;
    supplierHotelRoomType: string;
    maxOccupancy: number;
    minAdults: number;
    maxAdults: number;
    minChildren: number;
    maxChildren: number;
    standardOccupancy: number;
    occupancy: string;
    idRateScopeModel: number;
    rateScopeModel: string;
    rateScopeModelKey: string;
    adultsOnly: boolean;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export interface IContractMealPlanState {
    id: string;
    enabled: boolean;
    name: string;
    idMealPlan: number;
    mealPlan: string;
    isRoomOnly: boolean;
    isBedAndBreakfast: boolean;
    type: string;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export interface IContractRateDateState {
    id: string;
    idRoom: number;
    room: string;
    occupancy: string;
    maxOccupancy: number;
    adultsOnly: boolean;
    standardOccupancy: number;
    minAdults: number;
    maxAdults: number;
    minChildren: number;
    maxChildren: number;
    idRoomScopeModel: number;
    roomScopeModel: string;
    roomScopeModelKey: string;
    idRateScopeModel: number;
    rateScopeModel: string;
    rateScopeModelKey: string;
    idSeason: number;
    season: string;
    idMealPlan: number;
    mealPlan: string;
    baseRate: number;
    currentInventory: number;
    initialInventory: number;
    maxBookingAdvancedOffset: number;
    maxStayAtArrival: number;
    minBookingAdvancedOffset: number;
    minStayAtArrival: number;
    occupancyRates: IStaticRateDateOccupancyRateParsed;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export interface IMainInfoContractDetailState {
    id: string;
    enabled: boolean;
    key: string;
    idStatus: number;
    status: string;
    statusColor: string;
    idAgency: number;
    agency: string;
    idSupplierHotel: number;
    supplierHotel: string;
    name: string;
    description: string;
    idRatePlan: number;
    ratePlan: string;
    idRateScopeModel: number;
    rateScopeModel: string;
    rateScopeModelKey: string;
    activeFrom: Date | null;
    activeTo: Date | null;
    idCurrency: number;
    currency: string;
}

export interface IContractCancellationPolicyState {
    id: string;
    content: string;
    name: string;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

export interface IContractAgeSegmentState {
    id: number;
    name: string;
    age: number;
}

export interface IContractDetailState extends IMainInfoContractDetailState {
    seasons: IContractSeasonState[];
    rooms: IContractRoomState[];
    mealPlans: IContractMealPlanState[];
    rateDates: IContractRateDateState[];
    policies: IContractCancellationPolicyState[];
    ageSegments: IContractAgeSegmentState[];
}

export enum ContractDetailPanelNames {
    MAIN_INFO = 'main_info',
    SEASONS = 'seasons',
    ROOMS = 'room',
    MEAL_PLANS = 'meal_plans',
    CANCELLATION_POLICIES = 'policies',
    RATES = 'rate_dates',
}

export enum ContractsListViewType {
    TABLE = 'TABLE',
    CALENDAR = 'CALENDAR',
}

export interface IContractListFiltersState {
    Name: IFilterContent;
    IdStaticRateContractStatusType: IFilterContent;
    IdSupplierHotel: IFilterContent;
    IdAgency: IFilterContent;
    ActiveFrom: IFilterContent;
    ActiveTo: IFilterContent;
}

export interface IContractComplementaryDataOption {
    Id: string;
    Name: string;
    IdCurrency?: number;
    Key?: string;
    Icon?: string;
}

export interface IComplementaryDataState {
    data: IContractComplementaryDataOption[];
    isLoading: boolean;
    error: string | null;
    count: number;
}

export enum RATE_SCOPE_MODEL_KEY_ICON {
    OCCUPANCY = 'People',
    ROOM = 'Hotel',
    PERSON = 'Person',
    ROOM_EXTRA = 'GroupAdd',
}
